var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_1776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12.0006C23.9996 9.70738 23.3422 7.46232 22.1056 5.53116C20.8689 3.6 19.1048 2.06362 17.0221 1.1039C14.9394 0.144184 12.6254 -0.198683 10.3538 0.115894C8.08235 0.43047 5.94854 1.38932 4.20505 2.87892C2.46156 4.36852 1.18139 6.3265 0.516104 8.52105C-0.149185 10.7156 -0.171736 13.0548 0.451122 15.2618C1.07398 17.4688 2.31616 19.4511 4.03061 20.974C5.74506 22.4969 7.85999 23.4967 10.125 23.8551V15.4693H7.0785V12.0006H10.125V9.35681C10.125 6.34931 11.9167 4.68806 14.6572 4.68806C15.5573 4.70054 16.4551 4.77875 17.3438 4.92206V7.87556H15.8302C15.5723 7.84131 15.31 7.86553 15.0628 7.94643C14.8155 8.02734 14.5896 8.16285 14.4018 8.34293C14.214 8.52301 14.0691 8.74303 13.978 8.9867C13.8868 9.23037 13.8516 9.49144 13.875 9.75056V12.0006H17.2035L16.671 15.4693H13.875V23.8551C16.6978 23.4085 19.2686 21.9691 21.1248 19.796C22.9809 17.6228 24.0005 14.8585 24 12.0006Z",
    fill: "#C9FFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_1776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFacebook);
export default __webpack_public_path__ + "static/media/logo-facebook.472a10e53d3120802fb3c178d2173813.svg";
export { ForwardRef as ReactComponent };